import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCJGXjpA9hVe1ygN0DuT4o101qSEpKYhvs",
  authDomain: "sistema-d646c.firebaseapp.com",
  projectId: "sistema-d646c",
  storageBucket: "sistema-d646c.firebasestorage.app",
  messagingSenderId: "785908814496",
  appId: "1:785908814496:web:3697b5df47da93990fefc5",
  measurementId: "G-JW8XRVK6XF"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
